import { Colours } from "@alienheadwars/football-card-manager-model";
import { Card, Stack, Typography } from "@mui/material";
import { IMPACT_FONTS } from "../fonts/fonts";
import { CardDimensions } from "./playerCards/CardDimensions";

interface InlineCardComponentProps {
    colours: Colours
    avatar: any;
    title: string
    dimensions: CardDimensions;
    onClick?(): void;
    avatarSide?: 'left' | 'right'
    additionalChildren?: any
}

export const InlineCardComponent = (props: InlineCardComponentProps) => {
    const { colours, avatar, title, dimensions, onClick, avatarSide } = props
    return (
        <Card
            sx={{
                backgroundColor: colours.primaryColour,
                padding: dimensions.playerNameBackgroundPadding,
                justifyItems: 'center',
                display: 'inline-flex',
                position: 'relative',
                alignItems: 'center',
                cursor: onClick ? 'pointer' : 'default',
                maxWidth: '100%',
                boxSizing: 'border-box',
            }}
            onClick={onClick}
        >
            <Stack direction={avatarSide === 'right' ? 'row-reverse' : 'row'} spacing={dimensions.playerNameBackgroundPadding} sx={{
                width: '100%',
                justifyContent: 'space-between',
                justifyItems: 'center',
                display: 'inline-flex',
                position: 'relative',
                alignItems: 'center',
                margin: dimensions.playerNameBackgroundPadding,
            }}>
                <Card sx={{
                    height: dimensions.cardWidth,
                    width: dimensions.cardWidth,
                    position: 'relative',
                    backgroundColor: colours.secondaryColour,
                    // paddingRight: dimensions.playerNameBackgroundPadding
                }}>{/* No tutorials on in line player cards */}

                    {avatar}
                </Card>
                {dimensions.showName && <Typography
                    component="div"
                    sx={{
                        color: colours.primaryTextColour,
                        textAlign: 'center',
                        marginBottom: 0,
                        fontSize: dimensions.playerNameFontSize,
                        fontFamily: IMPACT_FONTS,
                        lineHeight: 1,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap'
                    }}
                >
                    {title}
                </Typography>
                }
                {props.additionalChildren}
            </Stack>
        </Card>
    );
};